import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable({ providedIn: 'root' })
export class MediaCacheService {
  private isBrowser: boolean;

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  /**
   * Register the custom bypass-by-default Service Worker.
   * Called once from AppComponent.ngOnInit().
   */
  register(): void {
    if (this.isBrowser && 'serviceWorker' in navigator) {
      navigator.serviceWorker.register('/media-sw.js', { scope: '/' })
        .then((reg) => console.log('[MediaCache] SW registered, scope:', reg.scope))
        .catch((err) => console.error('[MediaCache] SW registration failed:', err));
    }
  }

  /**
   * Wipe the media cache on logout.
   * Sends a postMessage to the custom SW which deletes the 'media-vault-v1' bucket.
   */
  clearCache(): void {
    if (this.isBrowser && 'serviceWorker' in navigator && navigator.serviceWorker.controller) {
      navigator.serviceWorker.controller.postMessage({ action: 'CLEAR_MEDIA_CACHE' });
    }
  }
}
